"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
require("./credentialSkillsBlock.scss");
const credentialSkillsBlockTranslations_json_1 = __importDefault(require("./credentialSkillsBlockTranslations/credentialSkillsBlockTranslations.json"));
const VerifySingleSkill_1 = __importDefault(require("../verifySingleSkill/VerifySingleSkill"));
const master_1 = require("../../../constants/master");
const subdomains_1 = require("../../../constants/subdomains");
function CredentialSkillsBlock(props) {
    props.addTranslation(credentialSkillsBlockTranslations_json_1.default);
    const config = (0, master_1.getMasterConfig)();
    const getSkillsTranslationKey = () => {
        return config.subDomain === subdomains_1.nationalBlackLawyersSubdomain ||
            config.subDomain === subdomains_1.nationalTrialLawyersSubdomain
            ? "activeMembership"
            : "skills";
    };
    return (react_1.default.createElement("div", { className: "credential-skills-block" },
        react_1.default.createElement("span", { className: "block-title" }, props.translate(getSkillsTranslationKey()).toString()),
        react_1.default.createElement("div", { className: "skills-row" }, props.skills
            .sort((a, b) => (a.title > b.title ? -1 : 1))
            .map((skill) => {
            return (react_1.default.createElement(VerifySingleSkill_1.default, { skillId: skill.id, skillTitle: skill.title, skillPageLink: props.skillsWithDescription &&
                    props.skillsWithDescription.includes(skill.id)
                    ? `/${props.activeLanguage ? props.activeLanguage.code : "en"}/skill/${skill.id}/`
                    : undefined, navigateToSkillPage: props.navigateToSkillPage }));
        }))));
}
exports.default = CredentialSkillsBlock;
